/* eslint-disable  no-unneeded-ternary */

import React from 'react';
import styled from 'styled-components';

export function Textarea({ name, value, placeholder, maxLength, onChange, onChangeFormik }) {
  const handleonChange = (e) => {
    const { value, name } = e.target;
    const valueMaxLength = maxLength === 0 || maxLength ? value.substring(0, maxLength) : value;
    onChange(valueMaxLength, name);
  };

  return <TextareaStyle name={name} value={value} placeholder={placeholder}
                        onChange={onChangeFormik? onChangeFormik : handleonChange} />;
}

const TextareaStyle = styled.textarea`
  border: 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lighter};
  padding: 16px 24px;
  background-color: white;
  min-height: 337px;
  resize: none;
  font-size: 1rem;
  line-height: 1.5;

  &:placeholder {
    color: rgba(23, 23, 23, 0.4);
  }

  @media ${({ theme }) => theme.device.mobile} {
  }
`;
